module.exports = __webpack_public_path__ + "6c37ca7c.svg";